import React, { FC, useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUIAutoCompleteInput } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { OmnichannelQuery } from '../../../../services/query';
import { SR } from '../../storeReturn.classes';

interface IProps {
    listele?: any;
    cities: any;
    onClose?: any;
}

export const StoreReturnFilter: FC<IProps> = ({ listele, cities, onClose }) => {
    const { t } = useTranslation();
    const [cityId, setCityID] = useState(0);
    const [counties, setCounties] = useState<any[]>([]);
    const [countyId, setCountyID] = useState(0);

    const getStoreCounty = (cityId: any) => {
        OmnichannelQuery.GetStoreCounty(cityId)
            .then((res: any) => {
                setCounties(res.data && [...[{ storeCountyId: 0, storeCountyName: t('general.all') }], ...res.data]);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    useEffect(() => {
        if (cityId !== 0) {
            getStoreCounty(cityId);
        }
    }, [cityId]);

    return (
        <form
            className={SR.filterForm}
            onSubmit={(e: any) => {
                e.preventDefault();
                listele(cityId, countyId);
            }}
        >
            <div className={`commentFilterContainer ${SR.filterFormBody}`}>
                <Grid container spacing={1} className={SR.filterFormGrid}>
                    <Box className={SR.filterDrawerHeader} sx={{ width: '100%' }}>
                        <SCUIGeneralDrawerHeader header={t('general.filter')} onClose={onClose} />
                    </Box>
                    {cities && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                            className={`${SR.filterCityField} ${SR.inputCity}`}
                        >
                            <SCUIAutoCompleteInput
                                list={cities}
                                onChange={(event: any, newValue: any) => {
                                    setCityID(newValue.storeCityId);
                                    setCounties([]);
                                }}
                                multiple={false}
                                txtPlaceHolder={t('general.cityName')}
                                searchValue="storeCityName"
                            />
                        </Grid>
                    )}
                    {counties && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                            className={`${SR.filterCountyField} ${SR.inputCounty}`}
                        >
                            <SCUIAutoCompleteInput
                                list={counties}
                                onChange={(event: any, newValue: any) => {
                                    setCountyID(newValue.storeCountyId);
                                }}
                                multiple={false}
                                txtPlaceHolder={'İlçe'}
                                searchValue="storeCountyName"
                            />
                        </Grid>
                    )}
                    <br />
                    <Grid
                        sx={{ marginLeft: 1 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                        className={SR.filterListAction}
                    >
                        <SCUIButton
                            text={t('general.list')}
                            type="primary"
                            sizeType="fixed"
                            buttonType="submit"
                            size={'l'}
                            fullwidth
                            className={SR.btnList}
                        />
                    </Grid>
                </Grid>
            </div>
        </form>
    );
};
